/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmUsageCompletions } from "../../funcs/llmUsageCompletions.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetCompletionsUsageRequest$inboundSchema,
};

export const tool$llmUsageCompletions: ToolDefinition<typeof args> = {
  name: "llm-usage-completions",
  description: `Get completions usage

Retrieve usage metrics for chat completions, aggregated from the ChatCompletion table.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmUsageCompletions(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
